import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API_END_POINTS } from "../ApiEndPoints";


export const getUserSubscriptionAPI = createAsyncThunk(
  "payment/getUserSubscription",
  async (token, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(API_END_POINTS.userSubscription,{
        headers: { Authorization: `Bearer ${token}` },
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const subscribePlanAPI = createAsyncThunk(
  "payment/subscribePlan",
  async ({ token, planId }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        API_END_POINTS.subscribePlan,
        { planId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const createCheckoutSessionAPI = createAsyncThunk(
  "payment/createCheckoutSession",
  async ({ token, planId, amount }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        API_END_POINTS.checkoutSession,
        { planId, amount },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const confirmPaymentIntentAPI = createAsyncThunk(
  "payment/confirmPaymentIntent",
  async ({ token, paymentIntentId, transactionId }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        API_END_POINTS.confirmPaymentIntent,
        { paymentIntentId, transactionId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const paymentSlice = createSlice({
  name: "payment",
  initialState: {
    subscription: null,
    checkout: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get User Subscription
      .addCase(getUserSubscriptionAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserSubscriptionAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.subscription = action.payload;
      })
      .addCase(getUserSubscriptionAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Subscribe Plan
      .addCase(subscribePlanAPI.fulfilled, (state, action) => {
        state.loading = false;
      })

      // Checkout Session
      .addCase(createCheckoutSessionAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.checkout = action.payload;
      })

      // Confirm Payment Intent
      .addCase(confirmPaymentIntentAPI.fulfilled, (state, action) => {
        state.loading = false;
      });
  },
});

export default paymentSlice.reducer;
